import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import { useEffect, useState } from "react";
import { FilterCobranca } from "../../components/filter/FilterCobranca";
import Colors from "../../components/constants/Colors";
import { Add, School } from "@mui/icons-material";

const currentUser = sessionStorage.getItem("userName");
const currentEmp = sessionStorage.getItem("empName");
const API_URL = sessionStorage.getItem("apiUrl");
const PAGE_SIZE = 30;

export const Cobranca = () => {
  const [registerCobranca, setRegisterCobranca] = useState(false);
  const [cpfAluno, setCpfAluno] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0); // DataGrid é 0-based
  const [rowCount, setRowCount] = useState(0);
  const [titleLoading, setTitleLoading] = useState("");
  const [valModalOpen, setValModalOpen] = useState(false);
  const [valErrors, setValErrors] = useState<string[]>([]);
  const [notFound, setNotFound] = useState(false);
  const [telaInicial, setTelaInicial] = useState(true);

  const [status, setStatus] = useState("");
  const [valorTotal, setValorTotal] = useState("");
  const [dataVencimento, setDataVencimento] = useState("");
  const [textoParcela, setTextoParcela] = useState("");
  const [ordemParcela, setOrdemParcela] = useState("");
  const [valorPago, setValorPago] = useState("");
  const [dataPagamento, setDataPagamento] = useState("");

  useEffect(() => {
    getCobrancas();
    if (API_URL === null) window.location.href = "/";
  }, []);

  useEffect(() => {
    getCobrancas();
  }, [page]);

  const getCobrancas = () => {};

  const iniciarCadastro = () => {
    setRegisterCobranca(true);
    setNotFound(false);
    setTelaInicial(false);
  };

  const handleBack = async () => {
    setNotFound(false);
    setRegisterCobranca(false);
    try {
      await getCobrancas(); // agora de fato espera
      if (rows.length === 0) {
        setTelaInicial(false);
        setNotFound(true);
      } else {
        setTelaInicial(true);
        setNotFound(false);
      }
    } finally {
      setLoading(false); // desliga sempre (sucesso/erro)
    }
  };

  // const searchCobranca = () => {};

  return (
    <>
      <Grid wrap="wrap">
        <Grid
          size={{ xs: 6, sm: 7, md: 8, xl: 10 }}
          style={{
            marginTop: "-1.6rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 className={css(styles.pageTitle)} style={{ marginRight: "4px" }}>
            {registerCobranca ? "Cadastrar cobrança" : "Cobrança"}
          </h3>

          <div style={{ display: "flex", gap: "15px" }}>
            {registerCobranca ? (
              <button className={css(styles.topBtn)} onClick={handleBack}>
                Voltar
              </button>
            ) : (
              <button onClick={iniciarCadastro} className={css(styles.topBtn)}>
                <Tooltip
                  title="Adicionar nova cobrança"
                  sx={{ cursor: "pointer" }}
                >
                  <Add />
                </Tooltip>
              </button>
            )}
          </div>
        </Grid>
      </Grid>

      <hr
        style={{
          color: "#eee",
          marginTop: "-0.55rem",
          marginBottom: "1rem",
        }}
      />

      {!registerCobranca ? (
        <FilterCobranca
          // searchCobranca={searchCobranca}
          cpfAluno={cpfAluno}
          setCpfAluno={setCpfAluno}
        />
      ) : null}

      {telaInicial ? (
        <Box>
          <Box
            sx={{ width: "100%", display: "grid", gap: 2, marginTop: 2 }}
          ></Box>
        </Box>
      ) : null}

      {registerCobranca ? (
        <Box sx={{ width: "100%", display: "grid", gap: 2, marginTop: 2 }}>
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <Typography
                    sx={{
                      backgroundColor: Colors.titleRowWithBackgroundColor,
                      pl: 1,
                      pt: 0.75,
                      mt: -1,
                    }}
                    variant="body2"
                    color={Colors.titleWithBackgroudColor}
                  >
                    <School fontSize={"inherit"} /> Informações de cobrança
                  </Typography>
                </Grid>

                <Grid size={{ xs: 12, sm: 8 }}>
                  <TextField
                    fullWidth
                    placeholder="Status"
                    value={status}
                    type="text"
                    onChange={(ev) => {
                      setStatus(ev.target.value);
                    }}
                    size={"small"}
                    color="primary"
                    label="Status"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      ) : null}

      {loading ? (
        <Box
          width={"100%"}
          height={"45vh"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid
            size={{ xs: 12, md: 12 }}
            textAlign={"center"}
            justifyContent={"center"}
            alignItems={"center"}
            bgcolor={"#eceff9ff"}
            borderRadius={5}
            padding={5}
            color={Colors.noResultFont}
          >
            <div
              style={{
                marginTop: "-0.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress color="primary" />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  color: "#4b4b4b",
                  fontSize: 14,
                  marginBottom: "-1rem",
                }}
              >
                {titleLoading}
              </p>
            </div>
          </Grid>
        </Box>
      ) : null}

      {notFound ? (
        <Box
          width={"100%"}
          height={"45vh"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid
            size={{ xs: 12, md: 12 }}
            height={{ md: "20%", xs: "50%" }}
            display={"inline-flex"}
            textAlign={"center"}
            justifyContent={"center"}
            alignItems={"center"}
            bgcolor={"lightyellow"}
            borderRadius={5}
            padding={5}
            color={Colors.noResultFont}
          >
            <p
              style={{
                color: "#4b4b4b",
                fontSize: 14,
              }}
            >
              Sua pesquisa não retornou nenhum resultado.
            </p>
          </Grid>
        </Box>
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  pageTitle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    color: "#4b4b4b",
  },
  input: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "#808080",
    transitionDuration: "0.2s",
  },
  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.3rem 0.42rem 0.4rem",
    width: "100%",
    marginTop: "1.95rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent",
      borderColor: "#669966",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent",
      borderColor: "#669966",
      opacity: 0.6,
    },
  },
  btnDisabled: {
    backgroundColor: "#B3B3B3",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#B3B3B3",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.3rem 0.42rem 0.4rem",
    width: "100%",
    marginTop: "1.95rem",
  },
  erro: {
    fontSize: 14,
    color: "red",
    textAlign: "center",
    fontWeight: 600,
    marginTop: "1rem",
    marginBottom: "-0.5rem",
  },
  topBtn: {
    cursor: "pointer",
    backgroundColor: "#004AAD",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#004AAD",
    borderRadius: 6,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    padding: "0.5rem 0.5rem 0.5rem 0.5rem",
    transitionDuration: "0.2s",
    ":hover": {
      color: "#186ad6ff",
      backgroundColor: "transparent",
      borderColor: "#186ad6ff",
    },
    ":active": {
      color: "#004AAD",
      backgroundColor: "transparent",
      borderColor: "#004AAD",
      opacity: 0.6,
    },
  },
});
